module.exports = __webpack_public_path__ + "images/rating-drops-blue-6942fe44.svg";